import axios from "axios";
// import {toast} from "vue3-toastify";

const apiUrl = process.env.VUE_APP_API_URL;


export const getProvinces = async () => {
    try {
        const response = await axios.get(`${apiUrl}/provinces`);
        return response.data; // اطلاعات پروفایل
    } catch (error) {
        return {
            success: false,
            message: error.response.data.message
        };
        // toast.error('خطا در دریافت اطلاعات');
        // console.error("Error fetching profile:", error);
        // //throw error;
    }
};

/**
 * بروزرسانی اطلاعات پروفایل کاربر
 * @param {Object} data داده‌های جدید پروفایل
 * @returns {Promise<Object>} پروفایل آپدیت شده
 */
export const getCities = async (id) => {
    try {
        const response = await axios.get(`${apiUrl}/provinces/${id}/cities`);
        return response.data; // پروفایل آپدیت شده
    } catch (error) {
        return {
            success: false,
            message: error.response.data.message
        };
        // throw error;
    }
};
